import React from 'react'
import './style.css'
import Conteudo from './conteudo/container'
import Nav from './nav/component'

export default (props) =>{
    return(
        <div className='header'>
            <div className='informacoes'>
                {props.telefone?props.telefone.map((x,k)=><span className='telefones' key={`telefones_${k}`}>{x}</span>):''}
                {props.endereco}
            </div>
            <Nav/>
            <Conteudo/>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/website/header/component.js